import React from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';

import { getField } from 'src/utils/EntryUtil';

import { BusyLoader } from '../BusyLoader/BusyLoader';
import { useSalesChannel } from '../SalesChannel/SalesChannel';
import { useValidPartnerInfo } from './UseValidPartnerInfo';
import { ValidationState } from './ValidationState';

interface IPartnerBump extends RouteComponentProps<{partnerName: string}> { }

export function buildRedirectPath(pathname: string, partnerName: string) {
  return `/shop${pathname.replace(new RegExp(`^\/partner\/${partnerName}`), '')}?partner=${partnerName}`;
}

const PartnerBump: React.FC<IPartnerBump> = ({ match, location }) => {
  const { i18n } = useTranslation();

  const { setTrackingHost } = useSalesChannel();

  const { pathname } = location;
  const { params } = match;

  // contentful request optimization in use: only certain fields are requested
  const { state, entry } = useValidPartnerInfo(i18n.language, params.partnerName);

  switch (state) {
    case ValidationState.INIT:
    case ValidationState.PENDING:
    case ValidationState.REDIRECT:
      return <BusyLoader />;
    case ValidationState.VALID:
      const [ host ] = getField(entry, 'referrerDomains', []);
      if (host) setTrackingHost(host);
    default:
      return <Redirect to={buildRedirectPath(pathname, params.partnerName)} />;
  }
};

const Routed = withRouter(PartnerBump);
type Routed = typeof Routed;

export { Routed as PartnerBump };
